import { render, staticRenderFns } from "./RuteUpload.vue?vue&type=template&id=3ec9aba5&scoped=true"
import script from "./RuteUpload.vue?vue&type=script&lang=js"
export * from "./RuteUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec9aba5",
  null
  
)

export default component.exports